var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.card.attached_assessment)?_c('AssessmentPresentCards',{staticClass:"fill-height",attrs:{"assessment":_vm.assessment,"cards":_vm.cards,"fullscreen":false,"mode":"edit"}}):_c('VAlert',{attrs:{"type":"info","value":true}},[_vm._v(" No worksheet attached ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }